import { useEffect, useState } from "react";
import { useSnapshot } from "valtio";
import { Col6, Cols } from "../Controls";
import { bookingsStore, configStore, entityStore, EntityV2Store } from "../state/CommonState";
import { ServerLists, tradeType } from "../StaticData";
import OneSelect6, { OneInput } from "./act-common";
import BookingsApi from "../state/bookings-api";
import { taskStore } from "./task-store";
import { AgCustlistInvoice } from "../components/AgCustlist";
import BranchApi from "../state/branch-api";
import { loader } from "../util/loader";

const getInitialInvoiceData = (renderData, brec) => {
  const company = brec?.company || "";
  const entityId = brec?.entityId || "";
  const country = brec?.country || "";
  const contactPerson = brec ? `${brec.firstName || ""} ${brec.lastName || ""}`.trim() : "";
  const contactNumber = brec?.phone || "";
  const email = brec?.emailid || "";

  return {
    exporter: {
      name: renderData?.shipperName || "",
      address: renderData?.shipperAddress || "",
      city: renderData?.shipperCity || "",
      state: renderData?.shipperState || "",
      zip: renderData?.shipperZip || "",
      country: renderData?.shipperCountry || "",
      contactPerson: renderData?.shipperContactPerson || "",
      contactNumber: renderData?.shipperContact || "",
      email: renderData?.shipperEmail || "",
    },
    importer: {
      name: renderData?.consigneeName || "",
      address: renderData?.consigneeAddress || "",
      city: renderData?.consigneeCity || "",
      state: renderData?.consigneeState || "",
      zip: renderData?.consigneeZip || "",
      country: renderData?.consigneeCountry || "",
      contactPerson: renderData?.consigneeContactPerson || "",
      contactNumber: renderData?.consigneeContact || "",
      email: renderData?.consigneeEmail || "",
    },
    invoicingParty: { name: company, entityId, branchId: '', address: '', city: '', state: '', zip: '', country, contactPerson, contactNumber, email },
    bookingParty: { name: company, entityId, branchId: '', address: '', city: '', state: '', zip: '', country, contactPerson, contactNumber, email },
    notifyParty1: { name: "", address: "", city: "", state: "", zip: "", country: "", contactPerson: "", contactNumber: "", email: "" },
    notifyParty2: { name: "", address: "", city: "", state: "", zip: "", country: "", contactPerson: "", contactNumber: "", email: "" },
    originAgent: {
      name: "",
      address: "",
      city: "",
      state: "",
      zip: "",
      country: "",
      contactPerson: "",
      contactNumber: "",
      email: "",
    },
    destinationAgent: {
      name: "",
      address: "",
      city: "",
      state: "",
      zip: "",
      country: "",
      contactPerson: "",
      contactNumber: "",
      email: "",
    },
  };
};

const sectionKeyMap = {
  Exporter: "exporter",
  Importer: "importer",
  InvoicingParty: "invoicingParty",
  BookingParty: "bookingParty",
  NotifyParty1: "notifyParty1",
  NotifyParty2: "notifyParty2",
  OriginAgent: "originAgent",
  DestinationAgent: "destinationAgent",
};

export default function InvoiceForm({ invoiceReq, renderData, setInvoiceReq }) {
  useSnapshot(configStore);
  useSnapshot(bookingsStore);
  useSnapshot(taskStore);

  const brec = bookingsStore.current;

  // const entityData =EntityV2Store.Cuslist.find(e => e.entityId === brec?.entityId) || {}


  const [invoiceData, setInvoiceData] = useState({});
  const [saveClicked, setSaveClicked] = useState(false);
  const [branchesBySection, setBranchesBySection] = useState({});
  const [selectedBranch, setSelectedBranch] = useState({});
  const [addressesBySection, setAddressesBySection] = useState({});
  const [selectedAddress, setSelectedAddress] = useState({});



  const fieldRules = {
    contactNumber: {
      sanitize: (v) => v.replace(/\D/g, ""),
      isInvalid: (v) => v && v.length !== 10,
    },
    zip: {
      sanitize: (v) => v.replace(/\D/g, ""),
      isInvalid: (v) => v && (v.length < 4 || v.length > 15),
    },
    email: {
      sanitize: (v) => v.replace(/\s/g, ""),
      isInvalid: (v) =>
        v && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v),
    },
  };

  const allEntities = EntityV2Store.Cuslist

  const linkedEntities = allEntities.filter(
    (e) =>
      e &&
      (
        brec.Entities?.linkedEntities?.includes(e?.entityId) ||
        e?.entityId === brec?.entityId
      )
  );

  const sanitizeValue = (field, value) => {
    return fieldRules[field]?.sanitize
      ? fieldRules[field].sanitize(value)
      : value;
  };

  const isInvalid = (field, value) => {
    return fieldRules[field]?.isInvalid
      ? fieldRules[field].isInvalid(value)
      : false;
  };

  const isSectionRequiredInvalid = (sectionKey, section) => {
    if (!section) return false;

    if (section.address?.trim() && !section.name?.trim()) {
      return true;
    }

    const requiredAlways = ["exporter", "importer"];
    if (requiredAlways.includes(sectionKey)) {
      return !section.name?.trim() || !section.address?.trim();
    }

    // if (sectionKey === "destinationAgent" && brec?.contract?.tradeType === tradeType.Export) {
    //   return !section.name?.trim() || !section.address?.trim();
    // }

    if (sectionKey === "originAgent" && brec?.contract?.tradeType === tradeType.Import) {
      return !section.name?.trim() || !section.address?.trim();
    }

    const notifyPartySections = ["notifyParty1", "notifyParty2"];
    if (notifyPartySections.includes(sectionKey)) {
      return section.name?.trim() && !section.address?.trim();
    }

    return false;
  };

  const isFieldRequired = (sectionKey, field, section) => {
    if (!section) return false;

    if (field === "name" && section.address?.trim()) {
      return true;
    }

    const requiredAlways = ["exporter", "importer"];
    if (requiredAlways.includes(sectionKey)) {
      return field === "name" || field === "address";
    }

    // if (sectionKey === "destinationAgent" && brec?.contract?.tradeType === tradeType.Export) {
    //   return field === "name" || field === "address";
    // }

    if (sectionKey === "originAgent" && brec?.contract?.tradeType === tradeType.Import) {
      return field === "name" || field === "address";
    }

    const notifyPartySections = ["notifyParty1", "notifyParty2"];
    if (notifyPartySections.includes(sectionKey)) {
      return field === "address" && section.name?.trim();
    }

    return false;
  };

  const isFieldRequiredInvalid = (sectionKey, field, section) => {
    if (!section) return false;

    if (isFieldRequired(sectionKey, field, section)) {
      return !section[field]?.trim();
    }

    return false;
  };

  const getFieldErrorClass = (sectionKey, field, section) => {
    if (!saveClicked) return "";
    if (isFieldRequiredInvalid(sectionKey, field, section)) return "input is-small is-danger";
    if (fieldRules[field] && isInvalid(field, section[field])) return "input is-small is-danger";
    return "";
  };

  const getFieldLabel = (sectionKey, field, label, section) => {
    return isFieldRequired(sectionKey, field, section) ? `${label} *` : label;
  };

  const toggleEntity = (section) => {
    setInvoiceData((prev) => {
      const toggled = !prev.__entityToggle?.[section];
      let clearedSection = prev[section];
      if (!toggled && clearedSection) {
        clearedSection = Object.fromEntries(
          Object.entries(clearedSection).map(([k, v]) =>
            k === 'label' ? [k, v] : [k, '']
          )
        );
      }
      if (toggled && clearedSection) {
        clearedSection = {
          ...clearedSection,
          branchId: '',
          address: '',
          city: '',
          state: '',
          zip: '',
          country: '',
        };
      }
      return {
        ...prev,
        __entityToggle: {
          ...prev.__entityToggle,
          [section]: toggled,
        },
        [section]: clearedSection,
      };
    });

    setSelectedAddress((prev) => ({
      ...prev,
      [section]: null,
    }));
    setSelectedBranch((prev) => ({
      ...prev,
      [section]: null,
    }));
    setBranchesBySection((prev) => ({
      ...prev,
      [section]: [],
    }));
    setAddressesBySection((prev) => ({
      ...prev,
      [section]: [],
    }));
  };

  const fetchBranches = (entity, key) => {
    try {
      loader.show()
      BranchApi.getAllBranches(entity?.entityId, (data) => {
        const branches = data || [];

        setBranchesBySection((prev) => ({
          ...prev,
          [key]: branches,
        }));
        const branchId = invoiceData[key]?.branchId;
        if (!branchId) return;

        const branch = branches.find(
          (b) => b.branchId === branchId || b._id === branchId
        );

        if (branch) {
          setSelectedBranch((prev) => ({
            ...prev,
            [key]: branch,
          }));

          setInvoiceData((prev) => ({
            ...prev,
            [key]: {
              ...prev[key],
              state: branch.state?.split("/")[0] || "",
              country: branch.country || "",
            },
          }));

          setAddressesBySection((prev) => ({
            ...prev,
            [key]: branch.branchAddresses || [],
          }));
        }
      });
    } catch (e) {
      console.log(e);

    } finally {
      loader.hide()
    }
  };




  useEffect(() => {
    if (!invoiceReq) return;
    if (Object.keys(invoiceData).length) return;

    const load = async () => {

      let data = brec.invoiceDetails

      if (!data) {
        data = getInitialInvoiceData(renderData, brec);
      }

      setInvoiceData(injectLabels(data));
    };

    load();
  }, [brec.invoiceDetails, invoiceData, invoiceReq, renderData]);

  const hasInvalidFields = () => {
    return Object.entries(invoiceData || {}).some(([sectionKey, section]) => {
      if (!section || sectionKey === "__entityToggle") return false;

      if (isSectionRequiredInvalid(sectionKey, section)) return true;

      return Object.keys(fieldRules).some((field) =>
        isInvalid(field, section[field])
      );
    });
  };


  const injectLabels = (data) => {
    const existingToggle = data.__entityToggle || {};
    return {
      __entityToggle: {
        exporter: !!(data.exporter?.entityId || existingToggle.exporter),
        importer: !!(data.importer?.entityId || existingToggle.importer),
        invoicingParty: !!(data.invoicingParty?.entityId || (existingToggle.invoicingParty ?? true)),
        bookingParty: !!(data.bookingParty?.entityId || (existingToggle.bookingParty ?? true)),
        notifyParty1: !!(data.notifyParty1?.entityId || existingToggle.notifyParty1),
        notifyParty2: !!(data.notifyParty2?.entityId || existingToggle.notifyParty2),
        originAgent: !!(data.originAgent?.entityId || existingToggle.originAgent),
        destinationAgent: !!(data.destinationAgent?.entityId || existingToggle.destinationAgent),
      },
      exporter: { label: "Exporter", ...data.exporter },
      importer: { label: "Importer", ...data.importer },
      invoicingParty: { label: "Invoicing Party", ...data.invoicingParty },
      bookingParty: { label: "Booking Party", ...data.bookingParty },
      notifyParty1: { label: "Notify Party 1", ...data.notifyParty1 },
      notifyParty2: { label: "Notify Party 2", ...data.notifyParty2 },
      originAgent: { label: "Origin Agent", ...data.originAgent },
      destinationAgent: { label: "Destination Agent", ...data.destinationAgent },
    };
  };





  useEffect(() => {
    if (!invoiceReq) {
      const data = getInitialInvoiceData(renderData, brec);
      setInvoiceData(data);
    }
  }, [brec, invoiceReq, renderData]);
  useEffect(() => {
    if (!invoiceReq) return;

    Object.entries(sectionKeyMap).forEach(([_, key]) => {
      const section = invoiceData[key];

      if (
        invoiceData.__entityToggle?.[key] &&
        section?.entityId &&
        !branchesBySection[key]
      ) {
        fetchBranches({ entityId: section?.entityId }, key);
      }
    });
  }, [invoiceData.__entityToggle, invoiceData]);




  if (!renderData) return null
  const update = (section, field, valueOrEvent) => {
    let value =
      valueOrEvent?.target !== undefined
        ? valueOrEvent.target.value
        : valueOrEvent;

    if (field === "country" && typeof value === "object") {
      value = value?.value || value?.name || "";
    }

    value = sanitizeValue(field, value);

    setInvoiceData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: value,
      },
    }));
  };

  const handleSave = async () => {
    setSaveClicked(true)
    if (hasInvalidFields()) {
      configStore.setModalMessage(
        "Please fill in mandatory fields before saving"
      );
      return;
    }

    try {
      loader.show()
      await BookingsApi.saveInvoiceDetails(brec._id, invoiceData);
      configStore.setModalMessage("Invoice details saved successfully");
      taskStore.booking.invoiceDetails = invoiceData
      brec.invoiceDetails = invoiceData
      setInvoiceReq(false)
    } catch (err) {
      console.error(err);
      configStore.setModalMessage("Failed to save invoice details");
    } finally {
      loader.hide()
    }
  };


  const renderSection = (sectionName, sectionData) => {
    const key = sectionKeyMap[sectionName];

    return (
      <table className="table is-fullwidth is-bordered is-narrow" key={key}>
        <thead>
          <tr>
            <th colSpan={10} style={{ background: "#ccccff", textAlign: "center" }}>
              {sectionData.label} Details
            </th>
          </tr>
        </thead>
        <tbody>
          {sectionName !== 'InvoicingParty' && sectionName !== 'BookingParty' && <tr>
            <td colSpan={10}>
              <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                <label className="checkbox">
                  <input
                    type="checkbox"
                    checked={invoiceData.__entityToggle?.[key]
                    }
                    onChange={() => toggleEntity(key)}
                  />
                  &nbsp; Select from Entity Master
                </label>
              </div>
            </td>
          </tr>}

          <tr>
            {sectionName === 'BookingParty' ? (
              <OneInput
                colSpan="3"
                label="Entity"
                value={sectionData.name || ""}
                isDisabled={true}
                onChange={() => { }}
              />
            ) : invoiceData.__entityToggle?.[key]
              ? (
                <AgCustlistInvoice
                  label={getFieldLabel(key, "name", "Entity", sectionData)}
                  name="entityId"
                  dataList={sectionName === 'InvoicingParty' || sectionName === 'BookingParty' ? linkedEntities : allEntities}
                  value={sectionData?.entityId}
                  isValid={!(saveClicked && isFieldRequiredInvalid(key, "name", sectionData))}
                  callback={(entity) => {

                    // CLEAR selection
                    if (!entity) {
                      setSelectedAddress((prev) => ({
                        ...prev,
                        [key]: null,
                      }));

                      setSelectedBranch((prev) => ({
                        ...prev,
                        [key]: null,
                      }));

                      setBranchesBySection((prev) => ({
                        ...prev,
                        [key]: [],
                      }));

                      setAddressesBySection((prev) => ({
                        ...prev,
                        [key]: [],
                      }));

                      setInvoiceData((prev) => ({
                        ...prev,
                        [key]: {
                          ...prev[key],
                          entityId: "",
                          branchId: "",
                          name: "",
                          address: "",
                          city: "",
                          state: "",
                          zip: "",
                          country: "",
                        },
                      }));

                      return;
                    }

                    // NORMAL selection
                    setSelectedAddress((prev) => ({
                      ...prev,
                      [key]: null,
                    }));
                    setSelectedBranch((prev) => ({
                      ...prev,
                      [key]: null,
                    }));

                    update(key, "branchId", "");
                    update(key, "address", "");
                    update(key, "city", "");
                    update(key, "zip", "");
                    update(key, "state", "");

                    update(key, "entityId", entity?.entityId);
                    update(key, "name", entity.entityName);

                    fetchBranches(entity, key);
                  }}
                />

              ) : (
                <OneInput
                  colSpan="3"
                  label={getFieldLabel(key, "name", "Entity", sectionData)}
                  value={sectionData.name || ""}
                  className={getFieldErrorClass(key, "name", sectionData)}
                  onChange={(e) => update(key, "name", e.target.value)}
                />
              )}
          </tr>
          {invoiceData.__entityToggle?.[key] && branchesBySection[key]?.length > 0 && (
            <tr>
              <td style={{ width: "120px", verticalAlign: "middle" }}>
                <label className="label is-small" style={{ marginBottom: 0 }}>
                  Branch
                </label>
              </td>

              <td colSpan={2}>
                <select
                  className="select is-small"
                  style={{ width: "100%" }}
                  value={sectionData?.branchId || ""}
                  onChange={(e) => {
                    const branch = branchesBySection[key].find(
                      (b) => b?.branchId === e.target.value || b?._id === e.target.value
                    );

                    setSelectedBranch((prev) => ({
                      ...prev,
                      [key]: branch,
                    }));
                    if (branch) {
                      update(key, "branchId", branch?.branchId || branch?._id);
                      update(key, "state", branch?.state?.split("/")[0]);
                      // update(key, "phone", branch.phone);
                      // update(key, "email", branch.email);
                      // update(key, "contactPerson", branch.firstName + ' ' + branch.lastName);
                      update(key, "country", branch.country);
                      update(key, "address", '');
                      update(key, "city", '');
                      update(key, "zip", '');


                      setAddressesBySection((prev) => ({
                        ...prev,
                        [key]: branch?.branchAddresses || [],
                      }));
                    }

                    setSelectedAddress((prev) => ({
                      ...prev,
                      [key]: null,
                    }));
                  }}

                >
                  <option value="">Select Branch</option>

                  {branchesBySection[key].map((r, i) => (
                    <option key={r?.branchId || i} value={r?.branchId}>
                      {`${r.state?.split("/")[0]} - ${r.gst?.length ? r.gst : r.tinNum
                        }`}
                    </option>
                  ))}
                </select>
              </td>
            </tr>
          )}
          {invoiceData.__entityToggle?.[key] &&
            addressesBySection[key]?.length > 0 ? (
            <tr>
              <td style={{ width: "120px", verticalAlign: "middle" }}>
                <label className="label is-small" style={{ marginBottom: 0 }}>
                  {getFieldLabel(key, "address", "Address", sectionData)}
                </label>
              </td>

              <td colSpan={2}>
                <select
                  className={getFieldErrorClass(key, "address", sectionData) ? "select is-small is-danger" : "select is-small"}
                  style={{ width: "100%" }}
                  value={selectedAddress[key]?.address || sectionData.address}
                  onChange={(e) => {
                    if (addressesBySection[key].length === 0) return;
                    const address = addressesBySection[key].find(
                      (a) => a.address === e.target.value
                    );

                    setSelectedAddress((prev) => ({
                      ...prev,
                      [key]: address,
                    }));

                    update(key, "address", address?.address);
                    update(key, "city", address?.city);
                    update(key, "zip", address?.pincode);
                  }}
                >
                  <option value="">Select Address</option>

                  {addressesBySection[key].map((a) => (
                    <option key={a.address} value={a.address}>
                      {`${a.address}`}
                    </option>
                  ))}
                </select>
              </td>
            </tr>) : <tr> <OneInput label="Address" colSpan="3" value={sectionData.address || ""} className={getFieldErrorClass(key, "address", sectionData)} onChange={(e) => update(key, "address", e.target.value)} /> </tr>
          }
          <tr>
            <OneInput label="City" value={sectionData.city || ""} onChange={(e) => update(key, "city", e.target.value)} />
            <OneInput label="PIN/ZIP Code" value={sectionData.zip || ""} onChange={(e) => update(key, "zip", e.target.value)} className={saveClicked && isInvalid("zip", sectionData.zip) ? "input is-small is-danger" : ""} />
          </tr>
          <tr>
            <OneInput label="State" value={sectionData.state || ""} onChange={(e) => update(key, "state", e.target.value)} />
            <OneSelect6
              key={`${key}-country`}

              label="Country"
              dataList={ServerLists.countryNameList}
              value={sectionData.country || ""}
              onChange={(val) => update(key, "country", val)}
            />
          </tr>
          <tr>
            <OneInput label="Contact Person" value={sectionData.contactPerson || ""} onChange={(e) => update(key, "contactPerson", e.target.value)} />
            <OneInput
              label="Contact Number"

              value={sectionData.contactNumber || ""}
              className={saveClicked && isInvalid("contactNumber", sectionData.contactNumber) ? "input is-small is-danger" : ""}
              onChange={(e) => update(key, "contactNumber", e.target.value)}
            />
          </tr>
          <tr>
            <OneInput

              label="Email ID"
              colSpan="3"
              value={sectionData.email || ""}
              className={saveClicked && isInvalid("email", sectionData.email) ? "input is-small is-danger" : ""}
              onChange={(e) => update(key, "email", e.target.value)}
            />
          </tr>
        </tbody>
      </table>
    );
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        top: '50px',
        background: "#fff",
        zIndex: 1000,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          padding: "12px 16px",
          borderBottom: "1px solid #ddd",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          background: "#f5f5f5",
        }}
      >
        <h3 style={{ margin: 0 }}>Invoice Party Details</h3>

        <button
          className="button is-small is-danger"
          onClick={() => setInvoiceReq(false)}
        >
          X
        </button>
      </div>

      <div
        style={{
          flex: 1,
          overflowY: "auto",
          padding: "16px",
        }}
      >
        <Cols>
          <Col6>{renderSection("Exporter", invoiceData.exporter || {})}</Col6>
          <Col6>{renderSection("Importer", invoiceData.importer || {})}</Col6>
        </Cols>

        {/* <Cols>
          <Col6>{renderSection("InvoicingParty", invoiceData.invoicingParty || {})}</Col6>
          <Col6>{renderSection("BookingParty", invoiceData.bookingParty || {}, true)}</Col6>
        </Cols> */}

        <Cols>
          <Col6>{renderSection("NotifyParty1", invoiceData.notifyParty1 || {})}</Col6>
          <Col6>{renderSection("NotifyParty2", invoiceData.notifyParty2 || {})}</Col6>
        </Cols>

        <Cols>
          {bookingsStore.current.contract.tradeType === tradeType.Import && <Col6>
            {renderSection(
              "OriginAgent",
              invoiceData.originAgent || {}
            )}
          </Col6>}

          {bookingsStore.current.contract.tradeType === tradeType.Export && (
            <Col6>
              {renderSection(
                "DestinationAgent",
                invoiceData.destinationAgent || {}
              )}
            </Col6>
          )}
        </Cols>
      </div>
      <div
        style={{
          borderTop: "1px solid #ddd",
          padding: "12px 16px",
          display: "flex",
          justifyContent: "flex-end",
          background: "#fff",
        }}
      >
        <button
          className="button is-primary"
          onClick={handleSave}
        >
          Save Invoice Details
        </button>
      </div>
    </div>
  );

}
